import { useState } from 'react';
// Компоненты пользовательского интерфейса
import '../../styles/Brigades.css';
import FilterForBrigades from './FilterForBrigades';
import TableForBrigades from './TablesForBrigades';
import MultiMarkerMap from '../Maps/MultiMarkerMap';
import HeaderForObject from '../CustomElements/HeaderForObject';
import translations from '../../content/PagesContent/BrigadePages/brigadePageTranslations.json';
// Кастомные хуки
import useTranslations from '../../customHook/useTranslations';
import { useFilterControl } from '../../customHook/useFilterControl';
import useInfiniteScroll from '../../customHook/useInfiniteScroll';
import { useSocketListener } from '../../customHook/useSocketListener';
// Действия Redux
import {
  clearBrigades,
  emitGetCoordsStart,
  emitGetCoordsStop,
  listenBrigadesCoords,
} from '../../redux/actions/brigades.action';
import { initBrigadesFromServer, listenUpdateBrigade } from '../../redux/actions/brigades.action';

function Brigades(props) {
  // получение словаря для статических данных в зависимости от выбранного языка
  const t = useTranslations(translations);
  const [isViewMap, setIsViewMap] = useState(false);
  const [isViewList, setIsViewList] = useState(true);

  // состояние для строки поиска
  const [filterInput, setFilterInput] = useState('');

  // Начальное состояние для стейта фильтрации передаем пропсами
  const initialFormData = {
    id: '',
    responsible: '',
    roadId: '',
    departmentId: '',
    stationId: '',
    start: '',
    finish: '',
    deviceId: '',
    directorateId: '',
    isWorking: '',
  };
  const [formData, setFormData] = useState(initialFormData);

  // хук для сброса фильтров и флага для отображения кнопки сброса
  const { resetFilters, showBtnReset } = useFilterControl(initialFormData, formData, setFormData, '', setFilterInput);

  // хук для запроса данных с учетом параметров поиска фильтрации и сортировки, и контроля скрола
  const { bottomBoundaryRef, handleSearch, mapSearchActive } = useInfiniteScroll(
    formData, // Данные фильтров
    filterInput, // Строка поиска
    setFilterInput, // Функция для изменения строки поиска
    initBrigadesFromServer, // Функция для инициализации данных
    'brigades', // Redux-селектор
    resetFilters, // Сброс фильтров
    clearBrigades, // Очистка стейта
    isViewMap // Флаг для остановки запросов
  );

  // старт прослушивания сокета
  useSocketListener([listenUpdateBrigade]);

  return (
    <div className="brigades">
      <FilterForBrigades
        setIsViewList={setIsViewList}
        setIsViewMap={setIsViewMap}
        isViewList={isViewList}
        isViewMap={isViewMap}
        initialFormData={initialFormData}
        formData={formData}
        setFormData={setFormData}
        showBtnReset={showBtnReset}
        resetFilters={resetFilters}
        t={t}
      />
      <div className="brigades_content">
        <HeaderForObject
          searchInput={filterInput}
          onFilterChange={(e) => {
            setFilterInput(e?.target?.value);
          }}
          onFilterSubmit={handleSearch}
        />

        {isViewList && (
          <TableForBrigades
            formData={formData}
            t={t}
            bottomBoundaryRef={bottomBoundaryRef}
          />
        )}
        {isViewMap && (
          <MultiMarkerMap
            emitStartFunction={emitGetCoordsStart}
            listenMarkersFunction={listenBrigadesCoords}
            listenStopFunction={emitGetCoordsStop}
            formData={formData}
            filterInput={filterInput}
            setSearchInput={setFilterInput}
            t={t}
            type="brigades"
            mapSearchActive={mapSearchActive}
          />
        )}
      </div>
    </div>
  );
}

export default Brigades;
